'use client';
import { createStyles, stylesReducer } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const emitStyles = (theme, { padding, color, variant, size })=>{
    const fillReducer = stylesReducer(variant);
    const shades = color && theme.fn.themeColor(color);
    const _color = shades && theme.fn.primaryShade(shades);
    return _extends({
        padding: theme.fn.space(padding)
    }, theme.fn.focusRing({
        color: (shades == null ? void 0 : shades.mid) || theme.palette.border.element
    }), {
        '& > svg': {
            width: size,
            maxWidth: size,
            height: size,
            maxHeight: size
        }
    }, fillReducer(null, {
        transparent: ()=>{
            const states = theme.fn.deriveStates(_color || theme.palette.text.secondary, 'dark');
            return {
                color: _color || theme.palette.text.secondary,
                borderRadius: theme.fn.borderRadius('0.5r'),
                '&:is(:hover,[data-hover=true])': {
                    color: states.hover,
                    background: 'none'
                },
                '&:is(:active,[data-active=true])': {
                    color: states.active,
                    background: 'none'
                }
            };
        },
        ghost: ()=>{
            const states = theme.fn.deriveStates(_color || 'transparent', 'light', 'overlay');
            return {
                color: _color || theme.palette.text.medium,
                borderRadius: theme.fn.borderRadius('round'),
                '&:is(:hover,[data-hover=true])': {
                    color: _color,
                    background: states.hover
                },
                '&:is(:active,[data-active=true])': {
                    color: _color,
                    background: states.active
                }
            };
        }
    }));
};
var useStyles = createStyles((theme, _param, _)=>{
    var { breakpoints } = _param, params = _object_without_properties_loose(_param, [
        "breakpoints"
    ]);
    return {
        root: _extends({
            cursor: 'pointer',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'fit-content',
            height: 'fit-content'
        }, theme.fn.transition(), emitStyles(theme, params), theme.fn.responsive(breakpoints)((localParams)=>emitStyles(theme, _extends({}, params, localParams))), {
            '&:is(:disabled,[data-disabled=true])': {
                cursor: 'not-allowed',
                pointerEvents: 'none',
                color: theme.palette.text.quaternary
            },
            '&[data-loading=true]': {
                pointerEvents: 'none'
            },
            '& > *': {
                display: 'block'
            }
        })
    };
});

export { useStyles as default };
//# sourceMappingURL=ActionIcon.styles.js.map
